export default function ExportIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 9.41419L11.293 13.7071L12.0001 14.4142L12.7072 13.7071L17.0001 9.41415V8.00008L17 8L15.5858 8L13.0001 10.5858L13.0001 5H11.0001L11.0001 10.5858L8.41423 8H7V9.41419ZM5.588 17.413C5.97933 17.8043 6.45 18 7 18H17C17.5507 18.0007 18.0217 17.805 18.413 17.413C18.8043 17.021 19 16.55 19 16V13H17V16H7V13H5V16C5.00067 16.5507 5.19667 17.0217 5.588 17.413Z"
        fill="#3C3C3C"
      />
    </svg>
  );
}
